import React from 'react'
// TODO move ui
// import { LayoutContent, Section, Dropdown, Button } from '@brainstud/schiphol-vtc-ui'
// import { MapWidget, MapOverlay, MapLayer, MapMenu, MapItem, Layer } from '@brainstud/react-widget-map'
import mapBaseImage from './assets/base.png'

// TODO remove mapwidget from package, try to import this component from package itself map-widget
const MapWidget = props => props.children
const MapOverlay = props => props.children
const MapLayer = props => props.children
const MapMenu = props => props.children
const MapItem = props => props.children
const Layer = props => props.children

class Map extends React.Component {
  state = {
    currentLayer: (this.props.app.globalMapLayers[0] && this.props.app.globalMapLayers[0].id) || 0,
  }

  get dropdownOptions() {
    return this.props.app.globalMapLayers.reduce((acc, item) => {
      return acc.concat({
        value: item.id,
        label: item.label,
      })
    }, [])
  }

  render() {
    return (
      <LayoutContent
        main={
          <Section style={{ height: '100%', padding: 0 }}>
            <MapWidget
              mapImage={mapBaseImage}
              mapBounds={[[0, 0], [12109, 11007]]}
              options={{ minZoom: -3 }}>
              <MapMenu>
                <MapItem center={[4389,5907]} zoom={-2}>
                  <MapOverlay>
                    {this.props.app.globalMapLayers.length > 1 &&
                      <Dropdown
                        value={this.state.currentLayer}
                        options={this.dropdownOptions}
                        onChange={value => this.setState({ currentLayer: value })} />
                      }
                  </MapOverlay>

                  <MapLayer>
                    {this.props.app.globalMapLayers.map(layer => {
                      return layer.id === this.state.currentLayer
                        ? <Layer
                            key={layer.id}
                            url={layer.layer}
                            center={layer.center}
                            zoom={layer.zoom}
                            bounds={[[0, 0], [12109, 11007]]} />
                        : null
                    })}
                  </MapLayer>
                </MapItem>
              </MapMenu>
            </MapWidget>

            <div style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              zIndex: '400',
              backgroundColor: '#fff',
            }}>
              <Button icon="close" label={false} iconSize="small" onClick={this.props.app.closeGlobalMap} />
            </div>
          </Section>
        } />
    )
  }
}

export default Map
